module.exports = __webpack_public_path__ + "img/bad1.3f652899.jpg";